import { LIMITES_META_INTERACTIVO_UX } from 'src/app/models/notificacion/whatsapp_flujo.model';

/**
 * Límites de los botones de la plantilla cuando la respuesta automática está
 * encendida.
 *
 * Meta define dos juegos distintos y los dos son correctos: una PLANTILLA admite
 * 10 quick-reply de 25 caracteres, y un MENSAJE INTERACTIVO `type: "button"`
 * admite 3 de 20. Con el flujo activo los quick-reply de la plantilla se envían
 * como mensaje interactivo, así que manda el más chico. Separado del componente
 * para poder probarlo sin `TestBed`.
 */

export interface IBotonPlantilla {
    tipo?: string;
    texto?: string;
}

const TIPO_QUICK_REPLY = 'QUICK_REPLY';

export const LIMITE_FLUJO = {
    ETIQUETA: LIMITES_META_INTERACTIVO_UX.BOTON_ETIQUETA_MAX_CARACTERES,
    CANTIDAD: LIMITES_META_INTERACTIVO_UX.BOTONES_MAX_REPLY,
} as const;

export const contarQuickReply = (botones: IBotonPlantilla[] | null | undefined): number => (
    Array.isArray(botones) ? botones.filter((boton) => boton?.tipo === TIPO_QUICK_REPLY).length : 0
);

/** Caracteres permitidos por botón según si el flujo está activo. */
export const limiteEtiqueta = (flujoActivo: boolean, limiteDePlantilla: number): number => (
    flujoActivo ? Math.min(LIMITE_FLUJO.ETIQUETA, limiteDePlantilla) : limiteDePlantilla
);

/** Quick-reply permitidos según si el flujo está activo. */
export const limiteCantidad = (flujoActivo: boolean, limiteDePlantilla: number): number => (
    flujoActivo ? Math.min(LIMITE_FLUJO.CANTIDAD, limiteDePlantilla) : limiteDePlantilla
);

/**
 * Los quick-reply cuyo texto ya no entra en el límite del flujo. `maxlength` no
 * recorta lo que estaba escrito antes de encender la respuesta automática, así
 * que hay que señalarlos.
 */
export const etiquetasQueExceden = (
    botones: IBotonPlantilla[] | null | undefined,
    flujoActivo: boolean,
): string[] => {
    if (!flujoActivo || !Array.isArray(botones)) {
        return [];
    }

    return botones
        .filter((boton) => boton?.tipo === TIPO_QUICK_REPLY)
        .map((boton) => String(boton?.texto || ''))
        .filter((texto) => texto.length > LIMITE_FLUJO.ETIQUETA);
};
